import React from "react";
import cn from "classnames";
import Icon from "../Icon";

const RemixItem = React.memo(({ section, index, active, setActive, handleRemix }) => {
  return (
    <div
      className={cn("remix__item", { active: index === active })}
      onMouseEnter={setActive}
    >
      <div className="remix__wrapper">
        <div className="remix__preview">
          <img
            className="remix__pic"
            src={section.background}
            alt="Preview"
          />
        </div>
      </div>
      <button
        className="remix__prev"
        onClick={() => handleRemix(section.type, "prev")}
      >
        <Icon.Next />
      </button>
      <button
        className="remix__next"
        onClick={() => handleRemix(section.type, "next")}
      >
        <Icon.Next />
      </button>
    </div>
  );
});

RemixItem.displayName = 'RemixItem';

export default RemixItem;
